export default {
    unit_type_event_delete_title: "Eliminar evento",
    unit_type_event_delete_success_message: "Se ha eliminado el evento",
    unit_type_event_delete_message: "¿Estás seguro de que quieres eliminar los tipos de evento de unidad seleccionados?",
}